import { cn } from "@repo/ui/lib/utils";
interface SectionHeaderProps {
	header?: string;
	className?: string;
}

const SectionHeader = ({ header,className }: SectionHeaderProps) => {
	return <h2 className={cn("text-3xl font-medium text-neutral-700",className)}>{header}</h2>;
};

export default SectionHeader;
